import { useLocation } from "react-router-dom";

import UsersTable from "./UsersTable";

export default function UserList() {
  const location = useLocation();

  const pathParts = location.pathname.split("/").filter(Boolean);
  const type = pathParts[pathParts.length - 1] || "all";

  return <UsersTable type={type} />;
}
